import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-281f16e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mt-3" }
const _hoisted_2 = { class: "p-mt-0" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "p-mt-3" }
const _hoisted_5 = { class: "p-float-label" }

import { ref, onMounted, computed } from "vue";
import { useI18n } from "vue-i18n";
import { helpers, minValue } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import InputNumber from "primevue/inputnumber";


export default /*#__PURE__*/_defineComponent({
  __name: 'Salary',
  props: ["candidate", "step"],
  setup(__props) {

const props = __props;
const user = ref(props.candidate);
const { t } = useI18n();

const rules = computed(() => {
    return {
        desiredSalary: {},
        desiredSalaryBonus: {
            minValue: helpers.withMessage(t("validate.minvalueorempty.error", { value: 500 }), minValue(500)),
        },
    };
});
const v$ = useVuelidate(rules, user);

onMounted(async () => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)("job.preferences.salary")), 1),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_unref(InputNumber), {
          modelValue: _unref(v$).desiredSalary.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).desiredSalary.$model) = $event)),
          mode: "currency",
          currency: "EUR",
          locale: "de-DE",
          class: _normalizeClass({ 'p-invalid': _unref(v$).desiredSalary.$error }),
          "data-cy": "wizard-salary"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("registration.tech.salary")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).desiredSalary.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(_unref(t)(error.$message)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_unref(InputNumber), {
          modelValue: _unref(v$).desiredSalaryBonus.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).desiredSalaryBonus.$model) = $event)),
          mode: "currency",
          currency: "EUR",
          locale: "de-DE",
          class: _normalizeClass({ 'p-invalid': _unref(v$).desiredSalaryBonus.$error }),
          "data-cy": "wizard-bonus"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("registration.tech.bonus")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).desiredSalaryBonus.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ])
  ], 64))
}
}

})